<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <b-form>
          <b-form-group
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="ชื่อรายการตรวจ"
            label-for="testNameLabel"
          >
            <b-form-input v-model="testInput.name" />
          </b-form-group>
          <b-form-group
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="ชื่อย่อ"
            label-for="abbreviationLabel"
          >
            <b-form-input v-model="testInput.abbreviation" />
          </b-form-group>
          <b-form-group
            v-if="testLevel === 'test'"
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="specimen Type"
            label-for="specimenTypeLabel"
          >
            <multiselect
              v-model="testInput.specimen_type"
              style="min-width: 200px;"
              label="name"
              track-by="name"
              :options="getSpecimenTypeAll"
              :multiple="true"
              :taggable="true"
            />
          </b-form-group>
          <b-form-group
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="ใช้ตัวย่อในรายงาน"
            label-for="displayAbbreviationLabel"
          >
            <b-form-select
              v-model="testInput.display_abbreviation"
              text-field="title"
              value-field="value"
              :options="displayAbbreviationList"
            />
          </b-form-group>
          <b-form-group
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="ราคา"
            label-for="priceLabel"
          >
            <b-form-input v-model="testInput.price" type="number" :value="0" />
          </b-form-group>
          <b-form-group
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="แยกจากประเภทรายการตรวจ"
            label-for="separateFromTestTypeLabel"
          >
            <b-form-select
              v-model="testInput.separate_from_test_type"
              text-field="title"
              value-field="value"
              :options="separateFromTestTypeList"
            />
          </b-form-group>
          <b-form-group
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="ประเภทข้อมูล"
            label-for="inputTypeLabel"
            description="หากเป็นหัวข้อใหญ่ สามารถสร้างรายการตรวจย่อยได้หลังจากสร้างรายการตรวจนี้แล้ว"
          >
            <b-form-select
              v-model="testInput.input_type"
              text-field="title"
              value-field="value"
              :options="inputTypeList"
              value="text"
            />
          </b-form-group>
          <b-form-group
            v-if="
              testInput.input_type === 'dropdown' ||
                testInput.input_type === 'checkbox' ||
                testInput.input_type === 'radio'
            "
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="ตัวเลือก"
            label-for="optionsLabel"
            style="text-align: left"
          >
            <b-row>
              <b-col cols="auto">
                <b-button variant="primary" @click="addOptionHandler">
                  เพิ่มตัวเลือก
                </b-button>
              </b-col>
              <b-col cols="auto" style="text-align: left">
                <small class="form-text text-muted"
                  >หากตัวเลือกเป็นประเภท checkbox หรือ radio
                  สามารถเพิ่มได้หลังจากบันทึก</small
                >
              </b-col>
            </b-row>
            <b-table
              responsive
              striped
              hover
              bordered
              :fields="optionsField"
              :items="options"
            >
              <template slot="has_sub_test" slot-scope="data">
                <div class="col-left">
                  {{ !data.item.input_type ? "ไม่มี" : data.item.input_type }}
                </div>
              </template>
              <template slot="for_specie_id" slot-scope="data">
                <div class="col-left">
                  {{
                    specieList.find((sp) => sp.id === data.item.for_specie_id)
                      ? specieList.find(
                          (sp) => sp.id === data.item.for_specie_id
                        ).species_name
                      : "ทั้งหมด"
                  }}
                </div>
              </template>
              <template slot="action" slot-scope="data">
                <b-container fluid>
                  <b-row align-h="center">
                    <b-col
                      v-if="
                        data.item.has_sub_test && data.item.id && !data.item.new
                      "
                      cols="auto"
                    >
                      <fa-icon
                        :icon="['fas', 'arrow-right']"
                        class="icon"
                        @click="openOptionModal(data.item.id)"
                      />
                    </b-col>
                    <b-col cols="auto">
                      <fa-icon
                        :icon="['fas', 'edit']"
                        class="icon warning"
                        @click="
                          editOption(
                            data.item.name,
                            data.item.has_sub_test,
                            data.item.for_specie_id
                          )
                        "
                      />
                    </b-col>
                    <b-col cols="auto">
                      <fa-icon
                        :icon="['fas', 'trash']"
                        class="icon danger"
                        @click="
                          deleteOption(
                            data.item.name,
                            data.item.has_sub_test,
                            data.item.for_specie_id
                          )
                        "
                      />
                    </b-col>
                  </b-row>
                </b-container>
              </template>
            </b-table>
          </b-form-group>
          <b-form-group
            v-if="
              testInput.input_type === 'text' ||
                testInput.input_type === 'number' ||
                testInput.input_type === 'dropdown' ||
                testInput.input_type === 'radio' ||
                testInput.input_type === 'checkbox'
            "
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="เครื่อง"
            label-for="machineLabel"
          >
            <b-form-select
              v-model="testInput.machine_id"
              text-field="name"
              value-field="id"
              :options="machineList"
            />
          </b-form-group>
          <b-form-group
            v-if="
              testInput.input_type === 'text' ||
                testInput.input_type === 'number' ||
                testInput.input_type === 'dropdown' ||
                testInput.input_type === 'radio' ||
                testInput.input_type === 'checkbox'
            "
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="Unit"
            label-for="unitLabel"
          >
            <b-form-select
              v-model="testInput.unit_id"
              text-field="name"
              value-field="id"
              :options="unitList"
            />
          </b-form-group>
          <b-form-group
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="Remark"
            label-for="remarkLabel"
          >
            <b-form-input v-model="testInput.remark" />
          </b-form-group>
          <b-form-group
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="แสดงคำเตือน Ref Range ในรายงาน"
            label-for="displayAbbreviationLabel"
          >
            <b-form-select
              v-model="testInput.display_ref_alert"
              text-field="title"
              value-field="value"
              :options="displayRefAlertList"
            />
          </b-form-group>
          <b-form-group
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="ใช้เฉพาะประเภทสัตว์"
            label-for="forSpecieIdLabel"
            description="หากใช้ทุกประเภทสัตว์ ไม่ต้องเลือก"
          >
            <b-form-select
              v-model="testInput.for_specie_id"
              text-field="species_name"
              value-field="id"
              :options="specieList"
            />
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
    <b-modal
      ref="optionModal"
      :title="optionModalTitle"
      size="xl"
      :no-enforce-focus="true"
      @ok="optionSubmit"
      @cancel="resetOptionInput"
      @close="resetOptionInput"
    >
      <option-input-modal :selected-options.sync="selectedOptions" />
    </b-modal>
    <b-modal
      ref="confirmOption"
      title="ยืนยันการเพิ่ม"
      ok-title="ยืนยัน"
      cancel-title="ยกเลิก"
      @ok="optionSubmit"
    >
      ต้องการเพิ่มใช่หรือไม่
    </b-modal>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import OptionInputModal from "../../components/Settings/OptionInputModal";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";

export default {
  name: "TestInputModal",
  components: {
    OptionInputModal,
  },
  props: {
    testInput: {
      type: Object,
    },
    options: {
      type: Array,
      default: () => [],
    },
    testLevel: {
      type: String,
      default: "test",
    },
  },
  data() {
    return {
      optionModalTitle: "",
      separateFromTestTypeList: [
        {
          title: "แยก",
          value: 1,
        },
        {
          title: "ไม่แยก",
          value: 0,
        },
      ],
      inputTypeList: [
        {
          title: "ตัวอักษร",
          value: "text",
        },
        {
          title: "ตัวเลข",
          value: "number",
        },
        {
          title: "ตัวเลือก Dropdown",
          value: "dropdown",
        },
        {
          title: "ตัวเลือก Radio",
          value: "radio",
        },
        {
          title: "Check Box",
          value: "checkbox",
        },
        {
          title: "หัวข้อใหญ่",
          value: "heading",
        },
      ],
      displayAbbreviationList: [
        {
          title: "แสดง",
          value: true,
        },
        {
          title: "ไม่แสดง",
          value: false,
        },
      ],
      displayRefAlertList: [
        {
          title: "แสดง",
          value: true,
        },
        {
          title: "ไม่แสดง",
          value: false,
        },
      ],
      hasSubTestsList: ["ไม่มี", "text", "number", "checkbox", "radio"],
      optionsField: [
        {
          key: "name",
          label: "ชื่อข้อมูล",
        },
        {
          key: "has_sub_test",
          label: "มีป้อนข้อมูลเพิ่มเติม",
        },
        {
          key: "for_specie_id",
          label: "สำหรับประเภทสัตว์",
        },
        {
          key: "action",
          label: "ACTION",
        },
      ],
      machineList: [],
      unitList: [],
      specieList: [],
      selectedOptions: [],
      selectedOptionId: null,
    };
  },
  computed: {
    ...mapGetters({
      getSpecies: "Species/getAll",
      getSpecimenTypeAll: "Test/getSpecimenType",
    }),
    optionsComputed: {
      get() {
        return this.testInput.options;
      },
      set(val) {
        this.$emit("update:testInput.options", val);
      },
    },
  },
  methods: {
    ...mapActions({
      getMachines: "Settings/getMachine",
      getUnits: "Settings/getUnits",
    }),
    async addOptionHandler() {
      const result = await Swal.mixin({
        confirmButtonText: "Next &rarr;",
        showCancelButton: true,
        progressSteps: ["1", "2", "3"],
      }).queue([
        {
          input: "text",
          title: "ชื่อตัวเลือก",
        },
        {
          title: "มีป้อนข้อมูลเพิ่มเติม",
          text: "มีป้อนข้อมูลเพิ่มเติมในตัวเลือก",
          input: "select",
          inputOptions: this.hasSubTestsList,
        },
        {
          title: "ใช้เฉพาะประเภทสัตว์",
          text: "หากใช้ทุกประเภทสัตว์ ไม่ต้องเลือก",
          input: "select",
          inputOptions: this.specieList.map((specie) => specie.species_name),
        },
      ]);

      if (result.value) {
        const name = result.value[0];
        const has_sub_test =
          "0" !== result.value[1] &&
          "1" !== result.value[1] &&
          "2" !== result.value[1];
        let input_type;
        if (result.value[1] !== "0") {
          input_type = this.hasSubTestsList[result.value[1]];
        }
        const for_specie_id =
          "0" === result.value[2] ? null : +result.value[2] + 1;
        let newOption = { name, has_sub_test, for_specie_id };
        if (input_type) {
          newOption = Object.assign(newOption, { input_type, new: true });
          if (input_type === "text" || input_type === "number") {
            newOption = Object.assign(newOption, { has_text_field: true });
          }
        }

        this.$emit("update:options", [...this.options, newOption]);
        // this.options.push({
        //     name,
        //     has_sub_test,
        //     for_specie_id
        // })

        // this.$emit('update:testInput.options', this.optionsComputed)

        // console.log(this.testInput, this.optionsComputed)
      }
    },
    deleteOption(name, has_sub_test, for_specie_id) {
      let options = this.options.filter(
        (option) =>
          option.name !== name &&
          option.has_sub_test !== has_sub_test &&
          option.for_specie_id !== for_specie_id
      );

      Swal.fire({
        title: "ยืนยันการลบ?",
        text: `คุณต้องการที่จะลบตัวเลือก ${
          this.options.find((option) => option.name === name).name
        } ใช่หรือไม่`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ใช่ ยืนยันการลบ!",
        cancelButtonAriaLabel: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          this.$emit("update:options", options);
        }
      });
    },
    async editOption(name, has_sub_test, for_specie_id) {
      let options = this.options;
      let optionIndex = options.findIndex(
        (option) =>
          option.name === name &&
          option.has_sub_test === has_sub_test &&
          option.for_specie_id === for_specie_id
      );

      const result = await Swal.mixin({
        confirmButtonText: "Next &rarr;",
        showCancelButton: true,
        progressSteps: ["1", "2", "3"],
      }).queue([
        {
          input: "text",
          title: "ชื่อตัวเลือก",
        },
        {
          title: "มีป้อนข้อมูลเพิ่มเติม",
          text: "มีป้อนข้อมูลเพิ่มเติมในตัวเลือก",
          input: "select",
          inputOptions: this.hasSubTestsList,
        },
        {
          title: "ใช้เฉพาะประเภทสัตว์",
          text: "หากใช้ทุกประเภทสัตว์ ไม่ต้องเลือก",
          input: "select",
          inputOptions: this.specieList.map((specie) => specie.species_name),
        },
      ]);

      if (result.value) {
        const name = result.value[0];
        const has_sub_test =
          "0" !== result.value[1] &&
          "1" !== result.value[1] &&
          "2" !== result.value[1];
        let input_type;
        if (result.value[1] !== "0") {
          input_type = this.hasSubTestsList[result.value[1]];
        }
        const for_specie_id =
          "0" === result.value[2] ? null : +result.value[2] + 1;

        if (input_type) {
          options[optionIndex].input_type = input_type;
          if (input_type === "text" || input_type === "number") {
            options[optionIndex].has_text_field = true;
          }
        } else {
          if (options[optionIndex].input_type) {
            delete options[optionIndex].input_type;
          }
        }

        options[optionIndex].name = name;
        options[optionIndex].has_sub_test = has_sub_test;
        options[optionIndex].for_specie_id = for_specie_id;
        options[optionIndex].new = true;

        this.$nextTick(() => {
          this.$emit("update:options", options);
        });

        // this.options.push({
        //     name,
        //     has_sub_test,
        //     for_specie_id
        // })

        // this.$emit('update:testInput.options', this.optionsComputed)

        // console.log(this.testInput, this.optionsComputed)
      }
    },
    optionSubmit() {
      let options = this.options;
      let optionIndex = options.findIndex(
        (option) => option.id === this.selectedOptionId
      );
      options[optionIndex].options = this.selectedOptions;
      this.$emit("update:options", options);
      this.resetOptionInput();
    },
    resetOptionInput() {
      this.selectedOptions = [];
      this.selectedOptionId = null;
    },
    clearOptionField() {
      this.selectedOptions = [];
      this.selectedOptionId = null;
    },
    openOptionModal(optionId) {
      this.$refs["optionModal"].show();
      let option = this.options.find((opt) => opt.id === optionId);
      this.optionModalTitle = `ตัวเลือกของ ${option.name}`;
      if (option.for_specie_id) {
        this.optionModalTitle += ` สำหรับ ${
          this.specieList.find((specie) => specie.id === option.for_specie_id)
            .species_name
        }`;
      } else {
        this.optionModalTitle += ` สำหรับทั้งหมด`;
      }

      this.selectedOptions = option.options;
      this.selectedOptionId = option.id;
    },
  },
  watch: {
    "testInput.input_type"(value) {
      if (this.testInput.parent_type) {
        this.testInput.has_sub_test = value === "heading";
      } else {
        this.testInput.has_sub_tests = value === "heading";
      }

      if (
        value !== "heading" &&
        value !== "dropdown" &&
        value !== "radio" &&
        value !== "checkbox"
      ) {
        delete this.testInput.options;
        this.$emit("update:options", []);
      }
    },
  },
  async mounted() {
    this.machineList = await this.getMachines();
    this.unitList = await this.getUnits();
    this.specieList = this.getSpecies;
  },
};
</script>

<style lang="scss" scoped>
.swall-overlay {
  z-index: 100005;
}
.swal-modal {
  z-index: 99999;
}
.icon {
  cursor: pointer;
  &.warning {
    color: #ffc107;
  }
  &.danger {
    color: #dc3545;
  }
  &.disable {
    opacity: 0.4;
    cursor: default;
  }
}
</style>
